// extracted by mini-css-extract-plugin
export default {"root":"Form_root__yq3Kw","layout-container":"Form_layout-container__ii7f7","container":"Form_container__2qi9x","saveButton":"Form_saveButton__UX1UR"};
    if(module.hot) {
      // 1763464084346
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  